/* eslint-disable no-underscore-dangle */

const SOUNDS = {
    opened: {
        alert: 'alert_violation',
        message: 'opened_chat_new_message',
    },
    closed: {
        alert: 'alert_violation',
        message: 'new_message',
    },
};
const SOUND_PATH = '/assets/sounds';

class NotificationsPlayer {
    private readonly _audioUrl: string;
    constructor(newMessage: boolean, newAlert: boolean, chatOpened: boolean) {
        const chatState = chatOpened ? 'opened' : 'closed';

        let sound;
        if (newMessage) {
            sound = SOUNDS[chatState].message;
        } else if (newAlert) {
            sound = SOUNDS[chatState].alert;
        }

        this._audioUrl = sound ? `${SOUND_PATH}/${sound}.mp3` : '';
    }

    async play() {
        if (!this._audioUrl) {
            return;
        }

        await new Audio(this._audioUrl).play();
    }
}

export default NotificationsPlayer;
